module.exports = __webpack_public_path__ + "static/media/UAV_monitoring_powietrza.114758eb.png";